import type { IIntegrationFormData } from "src/integrations/forms/IIntegrationFormData";
import {
  type IIntegrationFormDataShopify,
  integrationDataToIntegrationShopify,
  integrationToIntegrationDataShopify,
} from "src/integrations/forms/shopify/IIntegrationFormDataShopify";
import type { IntegrationShopify } from "src/integrations/objects/IntegrationShopify";
import type { IntegrationType } from "src/integrations/objects/IntegrationType";

export const INTEGRATION_SHOPIFY_IS_POST_CHECKOUT_SUBSCRIBE =
  "isPostCheckoutSubscribe";

export interface IIntegrationFormDataShopifyCheckout
  extends IIntegrationFormDataShopify {
  [INTEGRATION_SHOPIFY_IS_POST_CHECKOUT_SUBSCRIBE]: boolean;
}

export function integrationDataToIntegrationShopifyCheckout(
  integrationType: IntegrationType,
  integrationData: Partial<IIntegrationFormData>,
  integrationUuid?: string,
): Partial<IntegrationShopify> {
  return {
    ...integrationDataToIntegrationShopify(
      integrationType,
      integrationData,
      integrationUuid,
    ),
    isPostCheckoutSubscribe: Boolean(
      integrationData[INTEGRATION_SHOPIFY_IS_POST_CHECKOUT_SUBSCRIBE],
    ),
  };
}

export function integrationToIntegrationDataShopifyCheckout(
  integrationType: IntegrationType,
  integration: IntegrationShopify,
): Partial<IIntegrationFormDataShopifyCheckout> {
  return {
    ...integrationToIntegrationDataShopify(integrationType, integration),
    [INTEGRATION_SHOPIFY_IS_POST_CHECKOUT_SUBSCRIBE]:
      integration.isPostCheckoutSubscribe,
  };
}
